var map = {
	"./main/clever-insights-logo-component.svg": "279b",
	"./main/clever-insights-weclever-logo-component.svg": "5d46",
	"./main/icons/icon-arrow-down-component.svg": "ee86",
	"./main/icons/icon-arrow-right-component.svg": "3f8b",
	"./main/icons/icon-balloon-cross-component.svg": "c642",
	"./main/icons/icon-bar-chart-component.svg": "e908",
	"./main/icons/icon-celebration-component.svg": "3ac1",
	"./main/icons/icon-chart-growing-round-bars-bubble-component.svg": "b0bd",
	"./main/icons/icon-chat-bright-star-component.svg": "329f",
	"./main/icons/icon-chat-component.svg": "8c9d",
	"./main/icons/icon-close-component.svg": "4192",
	"./main/icons/icon-cloud-upload-component.svg": "7fa6",
	"./main/icons/icon-csat-heart-bubble-component.svg": "d463",
	"./main/icons/icon-csat-star-component.svg": "8775",
	"./main/icons/icon-custom-component.svg": "455a",
	"./main/icons/icon-dashboard-component.svg": "b503",
	"./main/icons/icon-demographic-profile-component.svg": "5843",
	"./main/icons/icon-dislike-component.svg": "0438",
	"./main/icons/icon-dollar-sign-bubble-component.svg": "dec5",
	"./main/icons/icon-expand-component.svg": "2a45",
	"./main/icons/icon-face-happy-component.svg": "dfce",
	"./main/icons/icon-face-neutral-component.svg": "2c8a",
	"./main/icons/icon-face-sad-component.svg": "38f5",
	"./main/icons/icon-feeling-negative-component.svg": "db35",
	"./main/icons/icon-feeling-neutral-component.svg": "45a9",
	"./main/icons/icon-feeling-positive-component.svg": "d013",
	"./main/icons/icon-filter-component.svg": "af08",
	"./main/icons/icon-flag-component.svg": "b7c0",
	"./main/icons/icon-flag-outline-component.svg": "7938",
	"./main/icons/icon-forum-component.svg": "11c3",
	"./main/icons/icon-groups-component.svg": "0653",
	"./main/icons/icon-info-component.svg": "65ed",
	"./main/icons/icon-insights-component.svg": "cb27",
	"./main/icons/icon-leads-component.svg": "efa5",
	"./main/icons/icon-like-component.svg": "9371",
	"./main/icons/icon-list-exclamation-component.svg": "f245",
	"./main/icons/icon-list-x-component.svg": "da7d",
	"./main/icons/icon-nav-business-insights-component.svg": "4736",
	"./main/icons/icon-nav-conversation-data-component.svg": "ddf0",
	"./main/icons/icon-nav-funnel-component.svg": "87d8",
	"./main/icons/icon-nav-leads-journey-component.svg": "c83c",
	"./main/icons/icon-nav-leads-list-component.svg": "0dc0",
	"./main/icons/icon-nav-leads-upload-component.svg": "bea9",
	"./main/icons/icon-nav-overview-component.svg": "9873",
	"./main/icons/icon-non-filter-component.svg": "87a3",
	"./main/icons/icon-person-search-component.svg": "13ff",
	"./main/icons/icon-rating-star-component.svg": "a88d",
	"./main/icons/icon-rating-star-outline-component.svg": "a141",
	"./main/icons/icon-result-component.svg": "4e20",
	"./main/icons/icon-reviews-component.svg": "ab42",
	"./main/icons/icon-robot-component.svg": "269c",
	"./main/icons/icon-rounded-important-component.svg": "6505",
	"./main/icons/icon-running-with-errors-component.svg": "7d2e",
	"./main/icons/icon-search-component.svg": "090e",
	"./main/icons/icon-search-data-component.svg": "e7d3",
	"./main/icons/icon-sparkles-component.svg": "68fb",
	"./main/icons/icon-star-component.svg": "5ded",
	"./main/icons/icon-star-outline-component.svg": "436b",
	"./main/icons/icon-stars-outline-component.svg": "ace2",
	"./main/icons/icon-timeline-component.svg": "d59b",
	"./main/icons/icon-trashcan-component.svg": "c407",
	"./main/icons/icon-trending-down-component.svg": "9d7f",
	"./main/icons/icon-trending-up-component.svg": "73bf",
	"./main/icons/icon-upload-component.svg": "3a5e",
	"./main/icons/icon-variation-down.svg": "7765",
	"./main/icons/icon-variation-null.svg": "b3fb",
	"./main/icons/icon-variation-up.svg": "e7ad",
	"./main/icons/icon-variation-zero.svg": "8662",
	"./main/icons/icon-world-component.svg": "32c3",
	"./main/stars-animation": "6818",
	"./main/stars-animation.json": "6818"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5876";